import { SILVER_MAX_BOOK_COUNT } from '@/utils/constant'

/* eslint-disable tailwindcss/no-custom-classname */
export const SilverOverLimit: React.FC = () => {
  return (
    <div className="p-[2px] border-[3px] border-[#fd8637] border-solid">
      <div className="p-[10px] bg-[#f9f8f3] border border-[#fd8637] border-solid">
        <div className="mb-[10px] text-xl leading-6">
          <span className="text-xl leading-5">
            シルバープランでは
            <span className="text-[#fd8637]">
              毎月{SILVER_MAX_BOOK_COUNT}冊まで
            </span>
            閲覧可能です。
            <br />
            既に今月は
            <span className="text-[#fd8637]">
              上限の{SILVER_MAX_BOOK_COUNT}冊
            </span>
            を閲覧しています。
          </span>
        </div>
        <div className="table mb-0 w-full max-w-full text-center">
          <div className="table-cell align-top">
            <a
              href={`${process.env.WWW_SERVER}/user/upgrade?from=summary`}
              className="inline-block relative after:absolute after:top-[calc(50%-4px)] after:right-0 pr-[10px] hover:pb-0 mr-[5px] after:w-[9px] after:h-[9px] text-[#2dacdb] hover:text-[#23527c] no-underline hover:underline after:border-t-[2px] after:border-r-[2px] border-b border-transparent after:border-[#fe8d42] border-solid after:border-solid after:rotate-45 cursor-pointer after:content-['']"
            >
              アップグレード
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
